import React, { useState } from "react";
import { ListAlt } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { useCanViewBom } from "fond/hooks/useCanViewBom";
import InteractiveBomModal from "fond/project/bom/InteractiveBom/InteractiveBomModal";
import { Architecture, Project } from "fond/types";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  project: Project;
  architecture: Architecture | null;
  handleClose: () => void;
}

const InteractiveBom: React.FC<IProps> = ({ project, architecture, handleClose }: IProps) => {
  const [modalOpen, showModal] = useState(false);
  const canViewBom = useCanViewBom(project);
  const handleClick = () => {
    if (canViewBom) {
      showModal(true);
      handleClose();
      trackPageMenuItemClick("project", "interactive_bom", project);
    }
  };

  return (
    <>
      <MenuItem data-testid="bom-button" onClick={handleClick} disabled={!canViewBom}>
        <ListItemIcon>
          <ListAlt />
        </ListItemIcon>
        Bill of Materials
      </MenuItem>
      {modalOpen && <InteractiveBomModal project={project} architecture={architecture} onClose={() => showModal(false)} />}
    </>
  );
};

export default InteractiveBom;
